import { useState, type ReactNode } from 'react';
import { inkOn } from '@core/palette';
import { initials } from '../people';
import { cn } from './cn';

// Кружок человека: картинка аккаунта, а без неё или если не загрузилась — инициалы на цвете.
export function Avatar({ name, color, src, size = 28, className, children }: { name: string; color: string; src?: string | null; size?: number; className?: string; children?: ReactNode }) {
  const [broken, setBroken] = useState(false);
  const showImage = !!src && !broken;
  return (
    <span
      className={cn('relative inline-flex items-center justify-center rounded-full font-bold select-none shrink-0 overflow-visible', className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4), background: showImage ? undefined : color, color: inkOn(color) }}
      aria-hidden
    >
      {showImage
        ? <img src={src} alt="" width={size} height={size} className="rounded-full w-full h-full object-cover" referrerPolicy="no-referrer" onError={() => setBroken(true)} />
        : initials(name)}
      {children}
    </span>
  );
}
